// https://api.notibot.ru/subscribers/{{shop_id}}

import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';


// ----------------------------------------------------------------------


const initialState = {
    isLoading: false,
    error: false,
    list: [],
    operations: [],
    balance: 0,
    count: 0,
    user: {}
};


const slice = createSlice({
    name: 'referals',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        setReferalsSuccess(state, action) {
            // state.isLoading = false;
            state.list = action.payload;
        },
        setCountSuccess(state, action) {
            // state.isLoading = false;
            state.count = action.payload;
        },
        setBalanceSuccess(state, action) {
            // state.isLoading = false;
            state.balance = action.payload;
        },
        setOperationsSuccess(state, action) {
            // state.isLoading = false;
            state.operations = action.payload;
        },
        setUserSuccess(state, action) {
            // state.isLoading = false;
            state.user = action.payload;
        },

    }
});

// Reducer
export default slice.reducer;

// Actions
export const { actions } = slice;

// ----------------------------------------------------------------------

export function getReferals(userid) {

    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {

            const response = await axios.get(`/referrals/tg${userid}`);
            // 7112999446
            // const response = await axios.get(`/referrals/tg6685175335`);
            // console.log("response REF" , response);
            const resp = response.data.data;
            // console.log("RESP" , resp);
            dispatch(slice.actions.setReferalsSuccess(resp?.referrals?.list || []));
            dispatch(slice.actions.setCountSuccess(resp?.referrals?.referrals_count || 0));
            dispatch(slice.actions.setBalanceSuccess(resp?.referrals?.partner_balance || 0));
            dispatch(slice.actions.setUserSuccess(resp?.user || {}));
            dispatch(slice.actions.setOperationsSuccess(resp?.operations || []));
            dispatch(slice.actions.stopLoading());
        } catch (e) {
            dispatch(slice.actions.stopLoading());
            dispatch(slice.actions.hasError(e));
        }
    }
}

export function setCurrentLead(lead) {
    return (dispatch) => {
        dispatch(slice.actions.setLead(lead));
    }
}


